/* istanbul ignore file */
import { createSelector } from 'reselect'
export const bookingSelector = (state) => state.booking

export const bookingDataSelector = createSelector(
    bookingSelector,
    (booking) => booking?.data
)

export const buildBookingStatusSelector = createSelector(
    bookingSelector,
    (booking) => booking?.status
)

export const buildBookingErrorSelector = createSelector(
    buildBookingStatusSelector,
    (status) => status?.error
)

export const buildBookingIsLoadingSelector = createSelector(
    buildBookingStatusSelector,
    (status) => status.creating
)

export const bookingIsAvailableSelector = createSelector(
    bookingDataSelector,
    (booking) => !!booking
)

export const updateBookingStatusSelector = createSelector(
    bookingSelector,
    (booking) => booking?.status
)

export const updateBookingErrorSelector = createSelector(
    updateBookingStatusSelector,
    (status) => status?.error
)

export const updateBookingIsLoadingSelector = createSelector(
    updateBookingStatusSelector,
    (status) => status.updating
)
